import {calculateVolumes} from "./volumeCalculator";
import {recalculatePrice} from "./costCalculator";
import {recalculateBuildTime} from "./buildTimeCalculator";

export async function recalculateBuildingParameters() {
    let volumes = calculateVolumes();
    recalculatePrice(volumes).then();
    recalculateBuildTime(volumes.total.unCutVolume, volumes.total.cutVolume).then();
}
